module.exports = __webpack_public_path__ + "7845f2fdc42f1d9e7cc1a3c1a7b8cd62.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-64.svg
// module id = 590
// module chunks = 0